import { __decorate, __metadata } from "tslib";
import { element } from 'angular';
import { Injectable } from 'angular-ts-decorators';
var TranslationService = (function () {
    function TranslationService() {
        this.systemDictionary = [];
        var systemHtml = element('#support-system-dictionary').html();
        if (systemHtml) {
            this.systemDictionary = JSON.parse(systemHtml);
            element('#support-system-dictionary').remove();
        }
    }
    TranslationService.prototype.getSystem = function (key) {
        var systemDictionaryItem = this.systemDictionary
            .filter(function (sd) { return sd.key === key; })[0];
        return (systemDictionaryItem === null || systemDictionaryItem === void 0 ? void 0 : systemDictionaryItem.value) || '';
    };
    TranslationService.$inject = [];
    TranslationService = __decorate([
        Injectable('translation'),
        __metadata("design:paramtypes", [])
    ], TranslationService);
    return TranslationService;
}());
export { TranslationService };
